// extracted by mini-css-extract-plugin
export default {"div":"NewSeat_div__aEbh6","book_Seats":"NewSeat_book_Seats__I7Cee","link":"NewSeat_link__TNP4K","h3":"NewSeat_h3__KrJTY","button":"NewSeat_button__i5g8m"};